module.exports = __webpack_public_path__ + "img/personagem-5.ed649001.png";